import type {
  BillingCurrency,
  TransactionCurrency,
} from '@contracts/payment/Currency';
import { roundToTwoDecimalsString } from '@contracts/utils/RoundingAmount';
import { theme } from '@src/common/styles/Theme';
import { isCurrencyDimmed } from '@src/orders/review/IsCurrencyDimmed';
import { BorderedTableCell } from '@src/orders/review/StyledTableRows';
import { useTranslation } from 'react-i18next';

export const CurrencyCell = ({
  currency,
  cellCurrency,
  value,
  prefix = false,
  className,
}: {
  currency: BillingCurrency;
  cellCurrency: TransactionCurrency;
  value: number;
  prefix?: boolean;
  className?: string;
}) => {
  const { t } = useTranslation();
  const formatTotal = (amount: number) =>
    t('reviewPermit.amountTotal', {
      amount: amount ? roundToTwoDecimalsString(amount) : '0',
    });

  return (
    <BorderedTableCell
      align="right"
      sx={{
        color: isCurrencyDimmed(currency, cellCurrency)
          ? theme.palette.secondary.secondaryFixedDim
          : 'inherit',
      }}
      className={className}
    >
      {prefix && cellCurrency} {formatTotal(value)}
    </BorderedTableCell>
  );
};
